import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LocalStorage} from '../../global/util/LocalStorage';
import {NgbDateStructUtil} from '../../global/util/NgbDateStructUtil';
import {PersonService} from '../../user/service/person.service';
import {Constant} from '../../global/util/Constant';
import HttpStatusCode from '../../global/util/HttpStatusCode';
import {Dialog} from '../../global/util/Dialog';
import {InformType} from '../../global/util/enum/InformType';
import {StringUtil} from '../../global/util/StringUtil';
import {Document} from '../../user/model/Document';

@Component({
  selector: 'app-identity-validation',
  templateUrl: './identity-validation.component.html',
  styleUrls: ['./identity-validation.component.css']
})
export class IdentityValidationComponent implements OnInit {
  public identityForm: FormGroup;
  public checkDigit: string;
  public lastName: string;
  public lastName2: string;
  public name: string;
  public birthLocation: string;
  public isPublic: boolean;
  public birthDate: string;
  public fatherName: string;
  public motherName: string;
  public registrationDate: string;
  public issueDate: string;
  public single = 'SOLTERO';
  public married = 'CASADO';
  public widower = 'VIUDO';
  public divorced = 'DIVORCIADO';
  public civilStatus = 'SOLTERO';
  public male = '';
  public female = '';
  public gender = '';
  public listValues: string[] = [];
  public values4validation: any[] = [];
  public person;
  public document: Document;
  public receivedPerson: any;


  constructor(public translate: TranslateService,
              private formBuilder: FormBuilder,
              public personService: PersonService,
              public activeModal: NgbActiveModal,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.receivedPerson = history.state.person;
    if (this.receivedPerson) {
      this.person = this.receivedPerson;
      console.log(this.person);
    }
    this.male = 'MASCULINO';
    this.female = 'FEMENINO';
    this.gender = 'MASCULINO';
    this.createForm();
    this.setRequiredFormControl();
  }

  accept() {
    if (this.identityForm.invalid) {
      this.markAsTouchedAllControls();
      return;
    }
    const checkedWorkflows = this.prepare4validation();
    this.person.valuesidentity = checkedWorkflows;
    let urlPerson;
    if (this.isPublic) {
      urlPerson = Constant.ROOT_API_V1.concat('/public/people/identity?uuid=', this.document._more.uuid);
    } else {
      urlPerson = Constant.ROOT_API_V1.concat('/people/identity');
    }
    this.personService.verifyIdentity(urlPerson, this.person).subscribe((next: any) => {
      const result = next;
      if (result.identityValidation) {
        this.activeModal.close({informType: InformType.Success, identityValidation: true});
      } else {
        Dialog.show(InformType.Warning, this.translate.instant('LABEL.IDENTITY-VALIDATION'), this.translate.instant('MESSAGE.FAILED-IDENTITY-VALIDATION'));
      }
    }, error => {
      if (error.status) {
        if (HttpStatusCode.NOT_FOUND === error.status) {
          Dialog.show(InformType.Danger, this.translate.instant('LABEL.IDENTITY-VALIDATION'), error.error.message);
        } else if (HttpStatusCode.CONFLICT === error.status) {
          Dialog.show(InformType.Danger, this.translate.instant('LABEL.IDENTITY-VALIDATION'), error.error.message);
        } else if (HttpStatusCode.FAILED_DEPENDENCY === error.status) {
          Dialog.show(InformType.Danger, this.translate.instant('LABEL.IDENTITY-VALIDATION'), error.error.message);
        } else {
          Dialog.show(InformType.Danger, this.translate.instant('LABEL.IDENTITY-VALIDATION'), this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
        }
      }
    });
  }

  private prepare4validation(): string {
    let value = '';
    for (const values of this.listValues) {
      const description = this.valueDescription(values);
      value += ''
        .concat(description)
        .concat(',')
        .concat(this.getValue4identityValidation(values))
        .concat('|');
    }
    return StringUtil.removeLastCharacter(value);
  }

  private markAsTouchedAllControls() {
    Object.values(this.identityForm.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  cancel() {
    this.activeModal.close({informType: InformType.Anything, identiyValidation: false});
  }

  public createForm() {
    this.identityForm = this.formBuilder.group(
      {
        checkDigit: [''],
        lastName: [''],
        lastName2: [''],
        name: [''],
        /*        birthLocation: [''],*/
        civilStatus: [''],
        gender: [''],
        birthDate: [''],
        fatherName: [''],
        motherName: [''],
        issueDate: [''],
      });
  }

  public valueDescription(value: string): string {
    switch (value) {
      case 'checkDigit':
        return 'VERIFICATION_DIGIT';
        break;
      case 'lastName':
        return 'LASTNAME_P';
        break;
      case 'lastName2':
        return 'LASTNAME_M';
        break;
      case 'name':
        return 'NAME';
        break;
      /*      case 'birthLocation':
              return 'UBIGEO_BIRTH';
              break;*/
      case 'civilStatus':
        return 'CIVIL_STATUS';
        break;
      case 'gender':
        return 'GENDER';
        break;
      case 'birthDate':
        return 'DATE_BIRTH';
        break;
      case 'fatherName':
        return 'NAME_FATHER';
        break;
      case 'motherName':
        return 'NAME_MOTHER';
        break;
      case 'issueDate':
        return 'DATE_ISSUE';
        break;
    }
  }

  public getValue4identityValidation(value: string): string {
    switch (value) {
      case 'checkDigit':
        return this.identityForm.get(value).value;
        break;
      case 'lastName':
        return this.identityForm.get(value).value;
        break;
      case 'lastName2':
        return this.identityForm.get(value).value;
        break;
      case 'name':
        return this.identityForm.get(value).value;
        break;
      /*      case 'birthLocation':
              return this.identityForm.get(value).value;
              break;*/
      case 'civilStatus':
        return this.identityForm.get(value).value;
        break;
      case 'gender':
        return this.identityForm.get(value).value;
        break;
      case 'birthDate':
        return NgbDateStructUtil.toString2(this.identityForm.get(value).value);
        break;
      case 'fatherName':
        return this.identityForm.get(value).value;
        break;
      case 'motherName':
        return this.identityForm.get(value).value;
        break;
      case 'issueDate':
        return NgbDateStructUtil.toString2(this.identityForm.get(value).value);
        break;
    }
  }

  public setValidators(value: string) {
    switch (value) {
      case 'checkDigit':
        this.identityForm.get(value).setValidators(Validators.compose([
          Validators.pattern('^[0-9]{1}'),
          Validators.required
        ]));
        break;
      case 'lastName':
        this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
        break;
      case 'lastName2':
        this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
        break;
      case 'name':
        this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
        break;
      /*      case 'birthLocation':
              this.identityForm.get(value).setValidators(Validators.compose([
                Validators.pattern('^[0-9]{6}'),
                Validators.required
              ]));
              break;*/
      case 'civilStatus':
        this.identityForm.get(value).setValidators(Validators.required);
        break;
      case 'gender':
        this.identityForm.get(value).setValidators(Validators.required);
        break;
      case 'birthDate':
        this.identityForm.get(value).setValidators(Validators.required);
        break;
      case 'fatherName':
        this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
        break;
      case 'motherName':
        this.identityForm.get(value).setValidators(Validators.compose([Validators.required,
          Validators.pattern('^([a-zA-ZñÑáéíóúÁÉÍÓÚ]+\\s)*[a-zA-ZñÑáéíóúÁÉÍÓÚ]{2,40}')]));
        break;
      case 'issueDate':
        this.identityForm.get(value).setValidators(Validators.required);
        break;
    }
    this.identityForm.get(value).updateValueAndValidity();
    this.listValues.push(value);
  }

  setRequiredFormControl() {
    // tslint:disable-next-line:prefer-const
    for (let index = 0; index < 4;) {
      const value = LocalStorage.getListValueReniec();
      if (this.listValues.filter(a => a === value).length <= 0) {
        this.identityForm.get(value).setValidators(Validators.required);
        this.setValidators(value);
        index++;
      }
    }
  }

  public isInvalidControl(ctrlName: string) {
    return this.identityForm.get(ctrlName).invalid && this.identityForm.get(ctrlName).touched;
  }

  public isNeed4identityValidation(identityValidation: string): boolean {
    return this.listValues.filter(value => value === identityValidation).length > 0;
  }

  public getErrorMessageBy(controlName: string): string {
    const control = this.identityForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasPatternError = control.hasError('pattern');
    switch (controlName) {
      case 'checkDigit':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-VERIFY-CODE');
        } else if (hasPatternError) {
          return this.translate.instant('MESSAGE.FAILED-VERIFY-CODE');
        }
        break;
      case 'lastName':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FATHERS-LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          return this.translate.instant('MESSAGE.FAILED-LAST-NAME');
        }
        break;
      case 'lastName2':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.MOTHERS-LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          return this.translate.instant('MESSAGE.FAILED-LAST-NAME1');
        }
        break;
      case 'name':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.NAME-IS-REQUIRED');
        } else if (hasPatternError) {
          return this.translate.instant('MESSAGE.FAILED-NAME');
        }
        break;
      /*      case 'birthLocation':
              if (hasRequiredError) {
                return this.translate.instant('MESSAGE.ENTER-BIRTH-LOCATION');
              } else if (hasPatternError) {
                return this.translate.instant('MESSAGE.FAILED-BIRTH-LOCATION');
              }
              break;*/
      case 'civilStatus':
        break;
      case 'gender':
        break;
      case 'birthDate':
        return this.translate.instant('MESSAGE.ENTER-BIRTH-DATE');
        break;
      case 'fatherName':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-FATHER-NAME');
        } else if (hasPatternError) {
          return this.translate.instant('MESSAGE.FAILED-FATHER-NAME');
        }
        break;
      case 'motherName':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-MOTHER-NAME');
        } else if (hasPatternError) {
          return this.translate.instant('MESSAGE.FAILED-MOTHER-NAME');
        }
        break;
      case 'issueDate':
        return this.translate.instant('MESSAGE.ENTER-ISSUE-DATE');
        break;
    }
  }
}
